import Services from '../views/ThirdParty/Services';
import Tel from '../views/ThirdParty/Tel';

let ThirdParty = [
  {
    path: 'Services',
    name: '服务管理',
    component: Services
  },
  {
    path: 'Tel',
    name: '便民电话',
    component: Tel
  }
];

export default ThirdParty;
